"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-nested-ternary */
const ButtonSortWrapper = _styledComponents.default.div.withConfig({
  displayName: "ButtonSort__ButtonSortWrapper",
  componentId: "design-system__sc-1n690hj-0"
})(["display:flex;align-items:center;justify-content:", ";.text{font-family:", ";font-size:", ";color:", ";&.sorted{font-weight:bold;}}.icons{display:flex;flex-direction:column;margin-left:", ";;> div{height:7px;margin:3px 0;}div:first-child{transform:rotate(180deg);}&.desc div:last-child svg path{fill:", ";}&.asc div:first-child svg path{fill:", ";}svg{width:12px;height:7px;display:block;path{fill:", ";}}}"], _ref => {
  let {
    justify
  } = _ref;
  return justify || 'normal';
}, _BaseTheme.default.type.family.content, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.textgray, _BaseTheme.default.distance.small, _BaseTheme.default.colors.textgray, _BaseTheme.default.colors.textgray, _BaseTheme.default.colors.lightgray);

const ButtonSort = _ref2 => {
  let {
    children,
    isSorted,
    isSortedDesc,
    justifyContent,
    size
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(ButtonSortWrapper, {
    justify: justifyContent
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text ".concat(isSorted ? 'sorted' : '')
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: "icons ".concat(isSorted ? isSortedDesc ? 'desc' : 'asc' : '')
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: size,
    type: "arrow"
  }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: size,
    type: "arrow"
  })));
};

ButtonSort.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  isSorted: _propTypes.default.bool,
  isSortedDesc: _propTypes.default.bool,
  justifyContent: _propTypes.default.string,
  size: _propTypes.default.string
};
ButtonSort.defaultProps = {
  children: undefined,
  isSorted: false,
  isSortedDesc: false,
  justifyContent: 'normal',
  size: undefined
};
var _default = ButtonSort;
exports.default = _default;